<template>
  <span>
    <template
      v-if="
        nomenclature &&
        nomenclature.unit_of_measurement &&
        nomenclature.unit_of_measurement.is_divisible &&
        nomenclature.unit_of_measurement.is_divisible === 1
      "
    >
      {{ amount }}
    </template>
    <template v-else>
      {{ amount.toString().replace(".000", "") }}
    </template>
  </span>
</template>

<script>
export default {
  name: "AmountOfNomenclature",
  props: {
    amount: null,
    nomenclature: null,
  },
};
</script>

<style scoped></style>
